import { defineAsyncComponent } from "vue";
import i18n from "../../../../i18n";
import store from "../../../../store/index";
import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../utils/form";
import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import {
    createFieldAttachment, createFieldCheckbox,
    createFieldDate,
    createFieldInput, createFieldSelect, createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import { numToPriceText } from "../../../../utils/util";

export const callPaymentBank = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "BANK_NAME", value: searchQuery });
export const callPaymentMethod = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PAYMENT_METHOD", value: searchQuery });
export const callProvince = ({ searchQuery }) => store.dispatch("resource/v1/master/province/cacheFindAll", {
        where: [
            { name: "nameTh", operator: "like", value: searchQuery }
        ]
    });
export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildren", {});
export const callRequestType = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_TYPE", value: searchQuery });
export const callLicenseRequestStatus = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "LICENSE_REQUEST_STATUS", value: searchQuery });

const FeeStatementList = defineAsyncComponent(() => import("../fee-statement/FeeStatementList"));

export const createFields = ({ props, data, key }) => {
    const { menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}licenseType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("views.feeStatement.licenseType")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: i18n.global.t("views.feeStatement.fishingLicenseFolk"),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}receiptCode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("views.feeStatement.receiptCode")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.receiptCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}requestCode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("views.feeStatement.requestCode")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requestCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: "requestDate",
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.requestDate"),
                inputProp: ({ field }) => lodash.merge(
                    {
                        value: modelRef.requestDate,
                        disabled: true
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}fullNameTh`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("views.feeStatement.fullNameTh")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requesterName,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}requesterIdCard`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("views.feeStatement.requesterIdCard")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequester?.idCard,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refPaymentStatus`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refPaymentStatus")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refPaymentStatus?.value,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: true,
                            dataProp: data,
                            itemsKey: `${prefix}feeStatements`,
                            fetchCriteria: data.feeStatement?.fetchCriteria,
                            canCreate: false,
                            canDelete: false,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "FeeStatementList" } })
                    );
                    return <FeeStatementList {...componentProp}></FeeStatementList>;
                }
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const itemsKey = `${prefix}feeStatements`;
                    const items = lodash.get(data.useForm.modelRef, itemsKey) || [];
                    const dutyTotal = items?.filter(d => d.refType?.key === "duty")?.map(d => d.netAmount || 0)?.reduce((a, b) => a + b, 0) || 0;
                    const feeTotal = items?.filter(d => d.refType?.key === "fee")?.map(d => d.netAmount || 0)?.reduce((a, b) => a + b, 0) || 0;
                    return <>
                        <div><b>{i18n.global.t("views.feeStatement.dutyTotal", { total: numToPriceText(dutyTotal) })}</b></div>
                        <div><b>{i18n.global.t("views.feeStatement.feeTotal", { total: numToPriceText(feeTotal) })}</b></div>
                        <div><b>{i18n.global.t("views.feeStatement.total", { total: numToPriceText(dutyTotal + feeTotal) })}</b></div>
                    </>;
                }
            }
        ]
    });
}

export const createInformPaymentFields = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refPaymentBank`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.refPaymentBank"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refPaymentBank,
                            "onUpdate:value": (value) => (model.refPaymentBank = value),
                            disabled: viewOnly,
                            list: callPaymentBank,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refBankProvince`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.refBankProvince"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.refBankProvince,
                            "onUpdate:value": value => {model.refBankProvince = value;},
                            disabled: viewOnly,
                            list: callProvince,
                            renderLabel: ({ item }) => (
                                <div>
                                    {item?.nameTh}
                                </div>
                            )
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
            }),

            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refPaymentMethod`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.refPaymentMethod"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refPaymentMethod,
                            "onUpdate:value": (value) => (model.refPaymentMethod = value),
                            disabled: viewOnly,
                            list: callPaymentMethod,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
            },
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}payFeeAtDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.payFeeAtDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.payFeeAtDate,
                            "onUpdate:value": value => (model.payFeeAtDate = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldAttachment({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attachmentFeeSlips`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.attachmentFeeSlips"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.attachmentFeeSlips,
                            group: "FeeSlip",
                            listType: "picture-card",
                            showUploadList: { showPreviewIcon: true, showRemoveIcon: false },
                            multiple: true,
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    );
                },
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}payDutyAtDate`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.payDutyAtDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.payDutyAtDate,
                            "onUpdate:value": value => (model.payDutyAtDate = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldAttachment({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attachmentDutySlips`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.attachmentDutySlips"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.attachmentDutySlips,
                            group: "DutySlip",
                            listType: "picture-card",
                            showUploadList: { showPreviewIcon: true, showRemoveIcon: false },
                            multiple: true,
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    );
                },
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}isApprovePayment`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                labelRender: () => i18n.global.t("views.feeStatement.status"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model?.isApprovePayment,
                            "onUpdate:checked": checked => {
                                if (checked) {
                                    model.isRejectPayment = false;
                                }
                                model.isApprovePayment = checked
                            },
                            disabled: viewOnly,
                            text: () => i18n.global.t("views.feeStatement.approvePayment"),
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            {
                key: `${prefix}isRejectPayment`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                colProp: () => ({ md: 12, xs: 0 }),
                formItemRender: () => {},
            },
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}isRejectPayment`,
                colProp: () => ({ xs: 24, md: 12 }),
                labelRender: () => " ",
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model?.isRejectPayment,
                            "onUpdate:checked": checked => {
                                if (checked) {
                                    model.isApprovePayment = false;
                                }
                                model.isRejectPayment = checked
                            },
                            disabled: viewOnly,
                            text: () => i18n.global.t("views.feeStatement.rejectPayment"),
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}paymentRemark`,
                colProp: () => ({ xs: 24, md: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("views.feeStatement.paymentRemark"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.paymentRemark,
                            "onUpdate:value": (value) => (model.paymentRemark = value),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
        ]
    });
}

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.licenseRequest.receiptCode"),
            dataIndex: "receiptCode",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.licenseRequest.paymentDate"),
            dataIndex: "paymentDate",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.licenseRequest.requestCode"),
            dataIndex: "requestCode",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.vessel.code"),
            dataIndex: "refVesselRequest.code",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.licenseRequest.requester"),
            dataIndex: "requesterName",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.licenseRequest.requestDate"),
            dataIndex: "requestDate",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refReceiveDept"),
            dataIndex: "refReceiveDept.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refReceiveDept.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refRequestType"),
            dataIndex: "refRequestType.value",
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refPaymentStatus"),
            dataIndex: "refPaymentStatus.value",
            inputProp: () => ({ list: callLicenseRequestStatus, optLabel: "value" }),
            search: { name: "refPaymentStatus.id" }
        })
    ];
    return columns;
};